export default "__VITE_ASSET__MtFoqFDK__"